import { useContext, useState } from "react";
import { BsFillCaretDownFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { apiRequest } from "../../api/baseApi";
import Layout from "../../components/layout/Layout";
import { ClientContext } from "../../state/ClientContext";
import "./AddNewAssignmentPage.css";

const AddNewAssignmentPageHeader = ({ children }) => {
  return (
    <div>
      <table>
        <td>
          <h1
            style={{
              textAlign: "left",
              fontSize: "2.6rem",
              color: "#fff",
              margin: "20px",
            }}
          >
            <strong>Add New Assignment</strong>
          </h1>
          <h5>
            You can assign as many clients to as many caregivers as you need.
            After assigning a client, they’ll be added to that caregiver’s
            remote care.
          </h5>
        </td>
        {children}
      </table>
    </div>
  );
};

const AddNewAssignmentPage = () => {
  const navigate = useNavigate();
  const { clients, caregivers, refetchClients } = useContext(ClientContext);
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedCaregivers, setSelectedCaregivers] = useState([]);
  const [isEdited, setIsEdited] = useState(false);

  const onInputChangeClients = (newValue) => {
    setSelectedClients(newValue);
    setIsEdited(true);
  };

  const onInputChangeCaregivers = (newValue) => {
    setSelectedCaregivers(newValue);
    setIsEdited(true);
  };

  async function assignCaregiver(caregiverIds, clientId) {
    const params = { caregiverIds: caregiverIds };

    const response = await apiRequest(`/clients/${clientId}/assignCaregiver`, {
      method: "POST",
      body: params,
      version: "v1",
    });

    await response.json();
  }

  const handleSetAssignment = async () => {
    let isSuccess = false;
    for (let m = 0; m < selectedClients.length; m++) {
      const client = selectedClients[m];
      const caregiverIds = selectedCaregivers.map((a) => a.value);
      try {
        await assignCaregiver(caregiverIds, client.value);
        isSuccess = true;
      } catch (error) {
        console.error("Failed to assign caregivers:", error);
      }
    }
    if (isSuccess) {
      setSelectedClients([]);
      setSelectedCaregivers([]);
      refetchClients();
      navigate("/assignment-set-success");
    }
  };

  return (
    <Layout
      containerClassName="bg-black text-white"
      showSideNav={false}
      isTouched={isEdited}
    >
      <div className="alerts-page-container">
        <AddNewAssignmentPageHeader />
        <div className="user-page-content">
          <div className="user-content-header">
            <div className="user-content-main-heading">
              <h4 className="user-content-title">Assign</h4>
            </div>
          </div>
          <div className="alert-lists-table-container">
            <div className="assignment-group">
              <div className="form-group labeled-group">
                <label htmlFor="date_from">Clients</label>
                <Select
                  defaultValue={[]}
                  isMulti
                  name="clients"
                  onChange={onInputChangeClients}
                  options={clients}
                  value={selectedClients}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
              <div className="form-group labeled-group">
                <label htmlFor="date_from">To Caregivers</label>
                <div className="field-icon-grp">
                  <span className="field-icon">
                    <BsFillCaretDownFill />
                  </span>
                  <Select
                    defaultValue={[]}
                    isMulti
                    name="caregivers"
                    onChange={onInputChangeCaregivers}
                    options={caregivers}
                    value={selectedCaregivers}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
              </div>
            </div>
            <div className="assignment-action-btns">
              <button
                className="go-btn"
                onClick={() => {
                  navigate("/assignment_center");
                }}
              >
                Cancel
              </button>
              <button className="go-btn" onClick={handleSetAssignment}>
                Set Assignment
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AddNewAssignmentPage;
